module.exports = Promise.all([parcelRequire.load("eMPWC"), parcelRequire.load("4GuH6")]).then(() => parcelRequire('8JWQd'));